import { useState } from 'react';
import OnboardingContainer from '$src/components/OnboardingContainer';
import useLocationContext from '$src/hooks/useLocationContext';
import { redirectToOnboardingSetupComplete } from '$src/utils/redirect';
import { handleBackToRingDashboard } from '$src/utils/handleBack';
import useStores from '$src/hooks/useStores';
import { SecurityCheckIcon } from '@ring-icons';
import aboutImage from '$src/assets/img/onboardingAbout.png';
import useRedirectBasedOnMonitoringStatus from '../Introduction/useRedirectBasedOnMonitoringStatus';

function PracticeMode() {
  const [loadingButton, setLoadingButton] = useState(false);
  const locationId = useLocationContext();
  const {
    sessionStore: { user, isMobile },
    modesStore,
  } = useStores();

  useRedirectBasedOnMonitoringStatus(user.user_id, locationId);

  const handleEndAlarmPractice = async () => {
    setLoadingButton(true);
    await modesStore.endAlarmPractice(user.user_id, locationId);
    await modesStore.fetchMonitoringStatus(user.user_id, locationId);
    redirectToOnboardingSetupComplete(locationId);
  };

  return (
    <OnboardingContainer
      headerTitle="Practice Mode"
      icon={SecurityCheckIcon}
      title="Your Alarm is set to Practice Mode"
      image={aboutImage}
      data-testid="practice-mode"
      subtitle={
        <div>
          <p>With Practice Mode you can discover Ring Alarm features without worrying about false alarms or accidental dispatches.</p>
          <br />
          <p>
            <b>Please end Practice Mode and switch to Professional Monitoring to make sure Virtual Security Guard is active. </b>
            <br />
            If you want to keep Practice Mode at the moment, you can switch to Professional Monitoring at any time in your Monitoring Settings.
          </p>
        </div>
      }
      primaryText="End Alarm Practice"
      secondaryText="Keep Alarm Practice"
      handleClose={() => handleBackToRingDashboard(isMobile)}
      hideBack
      secondaryActionHandler={() => redirectToOnboardingSetupComplete(locationId)}
      primaryActionHandler={() => handleEndAlarmPractice()}
      loading={loadingButton}
      warningOnClose
      warningOnBack
    />
  );
}
export default PracticeMode;
